import { render } from "./LabelWithIcon.vue?vue&type=template&id=ccea584a&scoped=true"
import script from "./LabelWithIcon.vue?vue&type=script&lang=js"
export * from "./LabelWithIcon.vue?vue&type=script&lang=js"

import "./LabelWithIcon.vue?vue&type=style&index=0&id=ccea584a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccea584a"]])

export default __exports__